import React from 'react';
import './index.css';
import App from './App.jsx';
import { render } from 'react-dom';

const root = document.getElementById("root");
render(<App />, root);

